// libs
import { BlogFilter }       from "../_components/_blog-filter";
import { BlogSortMobile }    from "../_components/_blog-sort-mobile";
import { VideoFrame }        from "../_components/_video-frame";
import { FilterMixitMobile } from '../_components/_filter-mixit-mobile';

window.$ = jQuery;

$( document ).ready( function () {
	BlogFilter();
	VideoFrame();
	FilterMixitMobile();
	BlogSortMobile();
} );